import { HeightIcon } from '@radix-ui/react-icons';

import { ColorPicker } from '../../../../../primitives/color-picker';
import { LabelWithoutRef } from '../../../../label/label-without-ref';

import { InputNumberWithSteps } from '../controls/input-number-with-steps';

import { cn } from '../../../../../utils/cn';

import { EMAIL_COLOR, EMAIL_COLORS } from '../../constants/colors';

type AppearanceProps = {
  backgroundColor?: string;
  className?: string;
  height?: string;
  color?: string;
  onLineColorChange?: (color: string) => void;
  onBackgroundColorChange?: (backgroundColor?: string | null) => void;
  onHeightChange?: (height: string) => void;
};

export function Appearance({
  backgroundColor,
  className,
  height,
  color,
  onBackgroundColorChange,
  onLineColorChange,
  onHeightChange,
}: AppearanceProps) {
  return (
    <div className={cn('space-y-2', className)}>
      <p className="text-xs font-medium">Apariencia</p>
      <div className="grid grid-cols-2 gap-x-4 gap-y-1">
        <div className="col-span-2">
          <div className="flex items-center gap-1">
            <HeightIcon className="size-4" />
            <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
              Alto
            </LabelWithoutRef>
          </div>
          <InputNumberWithSteps
            id="appearance-divider-height"
            max={8}
            min={1}
            steps={[1, 2, 3, 4, 5, 6, 7, 8]}
            value={height === '' || height === undefined ? null : Number(height)}
            onChange={(value) => {
              if (value !== null) {
                onHeightChange?.(String(value));
              }
            }}
          />
        </div>
        <div>
          <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
            Color
          </LabelWithoutRef>
          <ColorPicker
            colors={EMAIL_COLORS}
            noneColorLabel="Sin personalizar"
            value={color}
            onValueChange={(value) => onLineColorChange?.(value ?? EMAIL_COLOR.secondary)}
          />
        </div>
        <div>
          <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
            Fondo
          </LabelWithoutRef>
          <ColorPicker
            colors={EMAIL_COLORS}
            isCleanColorVisible
            noneColorLabel="Sin personalizar"
            value={backgroundColor}
            onValueChange={(value) => onBackgroundColorChange?.(value ?? null)}
          />
        </div>
      </div>
    </div>
  );
}
